var path = '/home/marialelinux/projects/www.enplug.com/src/templates/not.found.tpl.html';
var html = "<h1>Not Found - 404</h1>\n\n<h3> \n    {{ message }}\n</h3>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;